/**
 * Public permalink: /sport/:gameId/tournament/:tournamentId/match – tournament match list. Viewable without login.
 */

import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { getPublicMatches } from '../../api/readApi';
import { getGameById } from '../../constants/games';
import PublicLayout from '../../components/PublicLayout';
import { formatDateTime } from '../../utils/dateFormat';
import '../PublicPages.css';

export default function PublicTournamentMatchList() {
  const { gameId, tournamentId } = useParams();
  const game = getGameById(gameId);
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!tournamentId || !gameId) {
      setLoading(false);
      return;
    }
    let cancelled = false;
    getPublicMatches(gameId, tournamentId, 50)
      .then((res) => {
        if (cancelled) return;
        setMatches(res?.matches ?? []);
      })
      .catch(() => {
        if (!cancelled) setMatches([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, [gameId, tournamentId]);

  if (!game) {
    return (
      <PublicLayout>
        <p>Sport not found.</p>
      </PublicLayout>
    );
  }

  return (
    <PublicLayout title={`${game.icon} Tournament matches`}>
      <nav className="public-breadcrumb">
        <Link to={`/sport/${gameId}/tournament/${tournamentId}`} className="public-link">← Tournament</Link>
        <span style={{ margin: '0 8px' }}>·</span>
        <Link to={`/sport/${gameId}`} className="public-link">{game.name}</Link>
      </nav>
      <div className="public-card card-ui">
        {loading ? (
          <p className="public-loading">Loading…</p>
        ) : matches.length === 0 ? (
          <p className="public-no-data">No matches yet.</p>
        ) : (
          <ul className="public-match-list">
            {matches.map((m) => (
              <li key={m.id} className="public-match-item">
                <Link
                  to={`/sport/${gameId}/tournament/${tournamentId}/match/${m.id}`}
                  className="public-link public-match-link"
                >
                  <span className="public-match-meta">
                    {m.matchNumber != null ? `Match #${m.matchNumber}` : m.id.slice(0, 8)} · {m.status || 'scheduled'}
                    {m.scheduledAt && (
                      <> · {formatDateTime(m.scheduledAt?.toDate?.() ?? m.scheduledAt)}</>
                    )}
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </div>
    </PublicLayout>
  );
}
